/**
 * Analytics Tracker Component for Admin Panel
 * Tracks screen views when routes change
 */

import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { logScreenView } from '../utils/firebaseAnalytics';
import { trackPageView } from '../utils/analytics';
import { trackScreenView } from '../utils/featureTracking';
import { normalizeFeatureName } from '../utils/featureNameNormalizer';

export const AnalyticsTracker: React.FC = () => {
  const location = useLocation();
  const { user, backendUser } = useAuth();

  useEffect(() => {
    // CRITICAL: Don't track analytics if user is not authenticated
    // This prevents 401 errors during/after logout when redirecting to /store
    if (!user || !backendUser) {
      return;
    }

    // Get screen name from path
    const screenName = location.pathname || 'unknown';
    // Normalize feature name (replace IDs with placeholders)
    const normalizedScreenName = normalizeFeatureName(screenName);
    
    // Track screen view in Firebase Analytics (exclude SUPERADMIN)
    logScreenView(normalizedScreenName, backendUser?.role);
    
    // Track page view in Google Analytics (exclude SUPERADMIN)
    trackPageView(normalizedScreenName, backendUser?.role);
    
    // Track feature usage (screen view) with normalized feature name
    trackScreenView(normalizedScreenName, normalizedScreenName, backendUser?.role);
  }, [location.pathname, user, backendUser?.role]);

  return null;
};

